// ----------------------------------------------------------------------
// <copyright file="Izenda.TinyMCEjs" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function () {
  var PLUGINS = [
    'advlist autolink lists link image charmap print preview hr anchor pagebreak',
    'searchreplace wordcount visualblocks visualchars code fullscreen',
    'insertdatetime media nonbreaking save table contextmenu directionality',
    'emoticons template paste textcolor colorpicker textpattern imagetools noneditable'
  ];

  module.exports = {
    DEFAULT_CONFIG: {
      branding: false,
      contextmenu: "link image inserttable | cell row column deletetable | spell_checker",
      height: '100%',
      toolbar: false,
      menubar: false,
      resize: false,
      plugins: PLUGINS,
      paste_data_images: true,
      noneditable_noneditable_class: 'field-wrapper',
      valid_elements : '*[*]',
      extended_valid_elements: 'field[class|field-name],field-prop[key|value|type],repeater,embedded-report[id|class],span[class|style],datetime[class],subtotal[class],grandtotal[class],title,script[language|type|src],link[href|rel]',
      body_class: 'izenda-Tinymce',
      content_css: '/izenda-ui.css',
      //force_br_newlines: true,
      //force_p_newlines: false,
      forced_root_block: "div",
      // https://www.tinymce.com/docs/configure/content-filtering/#entity_encoding
      entity_encoding : "raw",
      valid_children: "+body[style|link]",
    },
    EVENTS: [
      'focusin', 'focusout', 'click', 'dblclick', 'mousedown', 'mouseup',
      'mousemove', 'mouseover', 'beforepaste', 'paste', 'cut', 'copy',
      'selectionchange', 'mouseout', 'mouseenter', 'mouseleave', 'keydown',
      'keypress', 'keyup', 'contextmenu', 'dragend', 'dragover', 'draggesture',
      'dragdrop', 'drop', 'drag', 'BeforeRenderUI', 'SetAttrib', 'PreInit',
      'PostRender', 'init', 'deactivate', 'activate', 'NodeChange',
      'BeforeExecCommand', 'ExecCommand', 'show', 'hide', 'ProgressState',
      'LoadContent', 'SaveContent', 'BeforeSetContent', 'SetContent',
      'BeforeGetContent', 'GetContent', 'VisualAid', 'remove', 'submit', 'reset',
      'BeforeAddUndo', 'AddUndo', 'change', 'undo', 'redo', 'ClearUndos',
      'ObjectSelected', 'ObjectResizeStart', 'ObjectResized', 'PreProcess',
      'PostProcess', 'focus', 'blur', 'dirty'
    ],
    FORMAT_CHANGES: [
      'alignleft', 'aligncenter', 'alignright', 'alignjustify',
      'p', 'blockquote', 'div', 'pre',
      'bold', 'italic', 'underline', 'strikethrough', 'superscript', 'subscript', 'code',
      'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
    ]
  };

}());



// WEBPACK FOOTER //
// ./ui/share/components/controls/TinyMCE/Izenda.TinyMCEConfig.js